// 校验某个key值权限
export function keyHasPermission(key, permissions = []) {
  return permissions.findIndex(item => item.resource === key) > -1;
}

// acl权限
export const AclKeys = {
  // 资源
  SelectTemplatesTab: "SelectTemplatesTab", //
  AuditTemplatesTab: "AuditTemplatesTab", // 
  BlockedTemplatesTab: "BlockedTemplatesTab", //
  TemplateAudit: 'TemplateAudit', // 短信模板审核按钮
}